<template>
  <div id="formTop">
    <el-dialog
      :title="'Save Application Keys'"
      :visible.sync="apiTokenReady"
      width="25%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="authx-codes">
        <div
          v-for="(code, index) in codes"
          :key="index"
          class="authx-codes--code"
        >
          <p>{{ code.label }}</p>
          <div>
            <span class="code">{{ oauthClient[code.key] || "-" }}</span>
            <span
              class="copy"
              v-clipboard:copy="oauthClient[code.key]"
              @click="copy(code.label)"
              ><i class="ra-icon--copy"></i
            ></span>
          </div>
        </div>
        <div class="note">
          <p>
            <span>Note - </span> <span>Client ID and Secret</span> should be
            saved as it won’t be viewed after you leave this page, unless you
            reset it.
          </p>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" size="medium" @click="complete"
          >Complete</el-button
        >
      </span>
    </el-dialog>
    <auth-x-form
      :action="createByDuplicate ? 'duplicate' : 'add'"
      @showApiToken="showTokens($event)"
    />
  </div>
</template>

<script>
import AuthXForm from "@/components/Products/AuthX/AuthXForm";
export default {
  name: "AuthXCreate",
  components: { AuthXForm },
  data() {
    return {
      apiTokenReady: false,
      aipTokenReady: false,
      oauthClient: {},
      codes: [
        {
          label: "Client Id",
          key: "id"
        },
        {
          label: "Client Secret",
          key: "secret"
        },
        {
          label: "Application Code",
          key: "appCode"
        }
      ]
    };
  },
  computed: {
    createByDuplicate() {
      return !!this.$route.params.id;
    }
  },
  methods: {
    showTokens(evt) {
      this.apiTokenReady = true;
      this.oauthClient = evt;
    },

    copy(label) {
      this.$message({
        message: `${label} Copied`,
        type: "success"
      });
    },

    complete() {
      this.$router.push({
        name: "authx.apps.overview",
        params: { id: this.oauthClient.appId }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rd-copy--input {
  opacity: 0;
}

.authx-codes {
  min-height: 200px;
  border-radius: 10px;
  //background: #eee;

  &--code {
    margin-bottom: 20px;

    > p {
      text-transform: uppercase;
      font-weight: 500;
      color: var(--ra-grey-tertiary);
    }

    div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code {
        font-size: 1.25rem;
        font-weight: 600;
        color: var(--ra-grey-primary);
        display: inline-block;
        margin-right: 5px;
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .copy {
        cursor: pointer;
        padding: 12px;
        border-radius: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #eee;

        i {
          font-size: 1rem;
          font-weight: 500;
          color: var(--ra-red-primary);
        }
      }
    }
  }
}

.note {
  p {
    color: var(--ra-grey-tertiary);
  }
  span {
    font-weight: 600;
    color: var(--ra-grey-primary);
  }
}
</style>
